/* eslint-disable react/require-default-props */
import React from 'react';
import ReactToggle from 'react-toggle';

import './Toggle.scss';

export interface ToggleProps {
  checked?: boolean;
  onChange: (value: boolean) => void;
}

const Toggle = React.forwardRef<HTMLDivElement, ToggleProps>(
  // eslint-disable-next-line arrow-body-style
  ({ checked, onChange, ...props }, ref) => {
    return (
      <ReactToggle
        {...props}
        ref={ref}
        className="Toggle"
        checked={checked || false}
        icons={false}
        onChange={() => onChange(!checked)}
      />
    );
  },
);

export default Toggle;
